import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import GrinRadioGroup from '../../common/GrinRadioGroup'

export const DoubleScanOptions = {
  Single: 'single',
  Double: 'double'
}

/**
 * Single/double scan choice, offered for the "Other" treatment type and for patients in
 * Retention. See `shouldOfferDoubleScanChoice` in utils/statusUtils for when to render it.
 *
 * Takes and returns a boolean; the string option values exist only because RadioGroup
 * reports its selection through `event.target.value`.
 */
const DoubleScanPicker = ({
  isDoubleScan = false,
  onSet = () => {},
  isDisabled = false,
  radioGroupClassName,
  size
}) => {
  const { t } = useTranslation()

  const options = useMemo(
    () => [
      { label: t('dialogs.scanFrequency.singleScan'), value: DoubleScanOptions.Single },
      { label: t('dialogs.scanFrequency.doubleScan'), value: DoubleScanOptions.Double }
    ],
    [t]
  )

  return (
    <GrinRadioGroup
      options={options}
      value={isDoubleScan ? DoubleScanOptions.Double : DoubleScanOptions.Single}
      setValue={value => onSet(value === DoubleScanOptions.Double)}
      isDisabled={isDisabled}
      radioGroupClassName={radioGroupClassName}
      size={size}
    />
  )
}

export default DoubleScanPicker
